import moment from 'moment'

export function capitalizeTitle (text) {
  if (text) {
    return text.toUpperCase()
  }
  return '<untitled>'
}

export function capitalize (text) {
  if (text) {
    return text.toUpperCase()
  }
  return ''
}

export function truncate (text, stop, clamp) {
  // display text up to length stop
  return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
}

export function utcLocalDate (datetime) {
  // Convert a timestamp from UTC timezone to the local timezone and return the date
  if (datetime === null || datetime === '' || datetime === undefined) {
    return ''
  }
  let gmtDateTime = moment.utc(datetime, 'YYYY-MM-DDTHH:mm:ssZ')
  return gmtDateTime.local().format('YYYY-MM-DD')
}

export function utcLocalDatetime (datetime) {
  // Convert a timestamp in UTC timezone to the local timezone and return the date-time
  if (datetime === null || datetime === '' || datetime === undefined) {
    return ''
  }
  let gmtDateTime = moment.utc(datetime, 'YYYY-MM-DDTHH:mm:ssZ')
  return gmtDateTime.local().format('YYYY-MM-DD HH:mm:ss')
}

const filters = {capitalize, truncate, utcLocalDate, utcLocalDatetime}

export default filters



// WEBPACK FOOTER //
// ./src/filters/index.js